export function ChartOfAccountsTopbar() {
  return <></>;
}
